import { render, staticRenderFns } from "./SearchBarResults.vue?vue&type=template&id=921fe49a&scoped=true&"
import script from "./SearchBarResults.vue?vue&type=script&lang=ts&"
export * from "./SearchBarResults.vue?vue&type=script&lang=ts&"
import style0 from "./SearchBarResults.vue?vue&type=style&index=0&id=921fe49a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "921fe49a",
  null
  
)

export default component.exports